import {useState, useEffect, SyntheticEvent } from 'react';
import Tabs from '@mui/material/Tabs';
import StyledTab from '../styledTab/styledTab';
import styledLabel from '@/pages/eventEditing/components/styledLabel/styledLabel'
import TabPanel from '../tabPanel/tabPanel'
import GeneralTabPanel from '@pages/eventEditing/components/tabPanels/generalTabPanel.tsx'
import DateAndLocationTabPanel from '@pages/eventEditing/components/tabPanels/dateAndLocationTabPanel.tsx'
import PhotoAndDescriptionTabPanel from  '@pages/eventEditing/components/tabPanels/photoAndDesriptionTabPanel.tsx'
import ConditionsTabPanel from '@pages/eventEditing/components/tabPanels/conditionsTabPanel.tsx'
import ContactsTabPanel from '@pages/eventEditing/components/tabPanels/contactsTabPanel.tsx'
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import CogwheelIcon from '@assets/svg/button-icons/cogwheel.svg?react';
import LocationIconCard from '@assets/svg/location_icon_for_editingPage.svg?react'
import BurgerMenuIcon from '@assets/svg/burger_menu_icon.svg?react'
import BellIcon from '@assets/svg/bell_icon.svg?react'
import { VerticalTabsProps } from '@pages/eventEditing/components/types.ts'
import EventDeletionComplex from '@pages/eventEditing/components/eventDeletionComplex/eventDeletionComplex.tsx'
import useUpdateEventRequest from '@pages/eventEditing/hooks/useUpdateEventRequest.ts'


function a11yProps(index: number) {
  return {
    id: `vertical-tab-${index}`,
    'aria-controls': `vertical-tabpanel-${index}`,
  };
}

export default function VerticalTabs ({ formik, photo, orgId, eventId }: VerticalTabsProps) {
  const [activeTab, setActiveTab] = useState(0)
  const { editHandler, isLoading } = useUpdateEventRequest()

  const handleChangeTab = (event: SyntheticEvent, newValue: number) => {
    setActiveTab(newValue);
  };
 
  return (
    <Box
      sx={{ flexGrow: 1, bgcolor: 'var(--Schemes--Surface)', display: 'flex', padding: '32px 8px' }}
    >
      <Tabs
        orientation="vertical"
        variant="scrollable"
        value={activeTab}
        onChange={handleChangeTab}
        aria-label="Vertical tabs example"
        TabIndicatorProps={{style: { display: 'none' }}}
      >
        <StyledTab label={styledLabel("Основные", <CogwheelIcon />)} {...a11yProps(0)} />
        <StyledTab label={styledLabel("Время и место", <LocationIconCard />)} {...a11yProps(1)} />
        <StyledTab label={styledLabel("Описание и фото", <BurgerMenuIcon />)} {...a11yProps(2)} />
        <StyledTab label={styledLabel("Разрешения", <BellIcon />)} {...a11yProps(3)} />
        <StyledTab label={styledLabel("Контакты", <span style={{fontSize:'16px'}}>📞</span>)} {...a11yProps(4)} />
        <EventDeletionComplex orgId={orgId} eventId={eventId}/>
      </Tabs>
      <TabPanel value={activeTab} index={0}>
        <GeneralTabPanel formik={formik}/>
        <Button onClick={() => editHandler(formik.values)} disabled={isLoading} sx={{mt: "18px"}} variant="text">Применить</Button>
      </TabPanel>
      <TabPanel value={activeTab} index={1}>
        <DateAndLocationTabPanel formik={formik}/>
        <Button onClick={() => editHandler(formik.values)} disabled={isLoading} sx={{mt: "18px"}} variant="text">Применить</Button>
      </TabPanel>
      <TabPanel value={activeTab} index={2}>
        <PhotoAndDescriptionTabPanel formik={formik} initialPhoto={photo}/>
        <Button onClick={() => editHandler(formik.values)} disabled={isLoading} sx={{mt: "18px"}} variant="text">Применить</Button>
      </TabPanel>
      <TabPanel value={activeTab} index={3}>
        <ConditionsTabPanel formik={formik} />
        <Button onClick={() => editHandler(formik.values)} disabled={isLoading} sx={{mt: "18px"}} variant="text">Применить</Button>
      </TabPanel>
      <TabPanel value={activeTab} index={4}>
        <ContactsTabPanel formik={formik}/>
        <Button onClick={() => editHandler(formik.values)} disabled={isLoading} sx={{mt: "18px"}} variant="text">Применить</Button>
      </TabPanel>
    </Box>
  );
}